// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[6].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[6].use[2]!../variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\---ui-components-src-input---BooleanInput-module__root {
}
`, "",{"version":3,"sources":["webpack://./../ui-components/src/input/BooleanInput.module.css"],"names":[],"mappings":"AAEA;AACA","sourcesContent":["@import \"../variables.css\";\n\n.root {\n}\n"],"sourceRoot":""}]);
// Exports
export var root = `---ui-components-src-input---BooleanInput-module__root`;
export default ___CSS_LOADER_EXPORT___;
